import BaseMode from './BaseMode'

/**
 * Режим «Переоформление» (rewrite).
 *
 * Правила, отличающиеся от оформления:
 *  - Нельзя удалить страхователя.
 *  - Нельзя поменять страхователя местами с застрахованным.
 *  - Черновики не сохраняются (весь контекст приходит из исходного полиса).
 *  - Первичные данные подтягиваются по ULID исходного полиса.
 *  - В форме поиска страхователя заблокирован ИИН (меняется из исходного
 *    полиса в случае первичной ошибки поиска).
 *
 *  Список ограничений по полям форм расширяется через `decorateFields` по мере
 *  поступления требований. Добавление нового правила — это ОДИН блок условий
 *  внутри `decorateFields`, в UI/модуле менять ничего не требуется.
 */
export default class RewriteMode extends BaseMode {
    static code  = 'rewrite'
    static title = 'Переоформление'
    static calcTitle = 'Расчитать'
    static checkoutTitle = 'Переоформить'

    /** POST: расчёт премии BPM (переоформление) */
    static calculateUrl = '/api/v2/calculate/ogpo/calculate-premium'
    /** POST: запуск оформления договора BPM (переоформление) */
    static checkoutUrl = '/api/v2/contract/bpm/checkout'

    static canAddInsurer()     { return false }
    static canDeleteInsurer()  { return false }
    static canEditInsurer()    { return true  }
    static canSwitchInsurer()  { return false }

    static canDeleteInsured()  { return true }
    static canEditInsured()    { return true }
    static canAddInsured()     { return true }

    static canDeleteVehicle()  { return true }
    static canEditVehicle()    { return true }
    static canAddVehicle()     { return true }

    static shouldSaveDraft()   { return false }

    /** В переоформлении нулевая премия — валидный результат расчёта. */
    static hasPremium(policy) {
        const premium = policy?.premium
        return premium !== null && premium !== undefined
    }

    static getTreatyStartDate(component) {
        return component?.today ?? null
    }

    static getTreatyMinDate(component) {
        return component?.today ?? null
    }

    static getTreatyTermsDictionary() {
        return {
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
        }
    }

    /**
     * Загружаем данные переоформляемого полиса по ULID.
     * Если ULID не указан — поведение сводится к дефолту (просто менеджеры),
     * чтобы пользователь хотя бы видел рабочую форму, а не пустую страницу.
     *
     * @param {Object} component — Vue-компонент продукта.
     */
    static loadInitialPolicy(component) {
        const ulid = component?.$route?.query?.ulid
        if (ulid && typeof component.loadRewritePolicy === 'function') {
            component.loadRewritePolicy(ulid)
            return
        }
        super.loadInitialPolicy(component)
    }

    /**
     * Переоформление запрещает менять идентификаторы страхователя.
     * Пока реализовано только для формы поиска (ИИН). Поля формы данных
     * добавим сюда же по мере определения списка.
     */
    static decorateFields(scope, settings, ctx) {
        const clientType = Number(ctx?.clientType)
        if (scope === 'clientSearch' && clientType === 1 && settings?.iin) {
            return {
                ...settings,
                iin: { ...settings.iin, disabled: true },
            }
        }
        return settings
    }
}
